import * as tslib_1 from "tslib";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectColorTransformChumk provides a shading method that changes the colour of a material analogous to a
 * ColorTransform object.
 */
var EffectColorTransformChunk = (function (_super) {
    tslib_1.__extends(EffectColorTransformChunk, _super);
    /**
     * Creates a new EffectColorTransformChumk.
     */
    function EffectColorTransformChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectColorTransformChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        var colorMultReg = registerCache.getFreeFragmentConstant();
        var colorOffsReg = registerCache.getFreeFragmentConstant();
        this._colorTransformIndex = colorMultReg.index * 4;
        //TODO: AGAL <> GLSL
        code += "mul " + targetReg + ", " + targetReg + ", " + colorMultReg + "\n" +
            "add " + targetReg + ", " + targetReg + ", " + colorOffsReg + "\n";
        return code;
    };
    /**
     * @inheritDoc
     */
    EffectColorTransformChunk.prototype._activate = function () {
        if (this._invalid) {
            var index = this._colorTransformIndex;
            var data = this._shader.fragmentConstantData;
            var rawData = this._method.colorTransform._rawData;
            data[index] = rawData[0];
            data[index + 1] = rawData[1];
            data[index + 2] = rawData[2];
            data[index + 3] = rawData[3];
            data[index + 4] = rawData[4];
            data[index + 5] = rawData[5];
            data[index + 6] = rawData[6];
            data[index + 7] = rawData[7];
        }
    };
    return EffectColorTransformChunk;
}(ShaderChunkBase));
export { EffectColorTransformChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectColorTransformChunk.js